import React from 'react';
import { Box, Typography } from '@mui/material';

import { CheckIcon } from '../../Icons';
import { SubmitButton } from '../Button/SubmitButton';


export const SuccessModal = ({
  successText,
  okButtonTitle,
  onButtonClick,
}: any) => {

  return (
    <Box sx={{
      padding: '32px',
      borderRadius: '16px',
      width: '360px',
      backgroundColor: 'white',
    }}>
      <Box style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
      }}>
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '50%',
          width: '80px',
          height: '80px',
          backgroundColor: 'rgba(35, 162, 109, 0.1)',
          marginBottom: '24px',
        }}>
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '50%',
            width: '40px',
            height: '40px',
            backgroundColor: '#23A26D',
            color: 'white',
            fontSize: '20px',
          }}>
            <CheckIcon fontSize="inherit"/>
          </Box>
        </Box>

        <Typography sx={{
          fontSize: '16px',
          fontWeight: '400',
          color: '#1F1F1F',
          marginBottom: '32px',
        }}>
          {successText}
        </Typography>

        <SubmitButton
          title={okButtonTitle}
          onClick={onButtonClick}
        />
      </Box>
    </Box>
  )
}
